import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/auth";
import { NAV } from "@/constants/testIds";

const Navbar = () => {
  const { user } = useAuth();
  const loc = useLocation();
  const isPaid = user?.subscription_status === "active";
  // Suppress the freemium banner on the account page (already shows pricing there).
  const showFreeBanner = user && !isPaid && loc.pathname !== "/account";
  return (
    <nav
      data-testid={NAV.root}
      style={{
        borderBottom: "1px solid var(--ax-border-bright)",
        background: "rgba(10,10,10,0.92)",
        position: "sticky",
        top: 0,
        zIndex: 50,
        backdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          maxWidth: 980,
          margin: "0 auto",
          padding: "0.85rem 1.25rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Link
          to="/"
          data-testid={NAV.brand}
          style={{
            color: "var(--ax-accent)",
            borderBottom: "none",
            fontWeight: 700,
            letterSpacing: "0.2em",
            fontSize: "1rem",
          }}
        >
          AXIOM<span className="cursor" />
        </Link>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            fontSize: 12,
            alignItems: "center",
          }}
        >
          {user && (
            <span
              data-testid={NAV.codename}
              className="muted"
              style={{ letterSpacing: "0.05em" }}
              title="Your anonymous codename"
            >
              {user.codename}
              {user.subscription_status === "active" && (
                <span className="pill active" style={{ marginLeft: 6 }}>
                  paid
                </span>
              )}
            </span>
          )}
          <Link
            to="/account"
            data-testid={NAV.account}
            style={{
              color: loc.pathname === "/account"
                ? "var(--ax-accent)"
                : "var(--ax-text-dim)",
              borderBottom: "none",
            }}
          >
            account
          </Link>
          <Link
            to="/admin"
            data-testid={NAV.admin}
            style={{
              color: loc.pathname.startsWith("/admin")
                ? "var(--ax-accent)"
                : "var(--ax-text-faint)",
              borderBottom: "none",
            }}
          >
            admin
          </Link>
        </div>
      </div>

      {showFreeBanner && (
        <div
          data-testid={NAV.freeBanner}
          style={{
            background: "rgba(78, 242, 194, 0.06)",
            borderTop: "1px solid rgba(78, 242, 194, 0.18)",
            color: "var(--ax-text-dim)",
            fontSize: 11,
            letterSpacing: "0.04em",
            padding: "0.32rem 1.25rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "0.8rem",
          }}
        >
          <span>
            <span style={{ color: "var(--ax-accent)", fontWeight: 700, letterSpacing: "0.12em" }}>
              AXIOM FREE
            </span>
            {" · upgrade for unlimited submissions and dossier creation"}
          </span>
          <Link
            to="/account"
            data-testid={NAV.freeBannerCta}
            style={{
              color: "var(--ax-accent)",
              borderBottom: "1px dashed var(--ax-accent)",
              fontWeight: 600,
            }}
          >
            upgrade →
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
